import { render, staticRenderFns } from "./ApprovePrintingBtn.vue?vue&type=template&id=556c1b2a&scoped=true&"
import script from "./ApprovePrintingBtn.vue?vue&type=script&lang=js&"
export * from "./ApprovePrintingBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556c1b2a",
  null
  
)

export default component.exports